import Abstract from '../../framework/Abstract';

import './B15-2-event-banner.scss';

class B152Banner extends Abstract {
	init() { }
}

export default B152Banner;
